import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';

import { SiteState } from '../shared/models';
import { getCropYear } from '../store/selectors';

@Component({
  selector: 'app-manure-space-customer-selection-custom-config',
  templateUrl: './customer-selection-custom-config.component.html',
  standalone: false,
})
export class ManureSpaceCustomerSelectionCustomConfigComponent implements OnInit, OnDestroy {
  protected readonly store = inject<Store<SiteState>>(Store);

  private readonly destroyed$ = new Subject<boolean>();
  cropYear: number;
  cropYear$ = this.store.select(getCropYear);

  ngOnInit(): void {
    this.cropYear$.pipe(takeUntil(this.destroyed$)).subscribe((cropYear) => {
      if (cropYear) {
        this.cropYear = cropYear;
      } else {
        this.cropYear = new Date().getFullYear();
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
